import { components } from 'services/api/lna-api-v2.schema';

// client login
export type ClientLoginListItemPagedResponse = components['schemas']['ClientLoginListItemPagedResponse'];
export type ClientLoginListItem = components['schemas']['ClientLoginListItem'];
export type ClientLoginListByClientIdItem = components['schemas']['ClientLoginListByClientIdItem'];
export type ClientLoginListByLegalEntityIdItem = components['schemas']['ClientLoginListByLegalEntityIdItem'];

//client notes
export type ClientNoteListItemPagedResponse = components['schemas']['ClientNoteListItemPagedResponse'];
export type ClientNoteListItem = components['schemas']['ClientNoteListItem'];
export type CreateClientNoteRequest = components['schemas']['CreateClientNoteRequest'];
export type ClientNoteCard = components['schemas']['ClientNoteCard'];
export type UpdateClientNoteRequest = components['schemas']['UpdateClientNoteRequest'];
export type ClientNoteListByClientIdItem = components['schemas']['ClientNoteListByClientIdItem'];
export type ClientNoteFileView = any; //?components['schemas']['ClientNoteFileView'];

// client notifications
export type ClientNotificationListItemPagedResponse = components['schemas']['ClientNotificationListItemPagedResponse'];
export type ClientNotificationByClientIdListItemPagedResponse = components['schemas']['ClientNotificationByClientIdListItemPagedResponse'];
export type ClientNotificationByClientIdListItem = components['schemas']['ClientNotificationByClientIdListItem'];
export type CreateClientNotificationRequest = components['schemas']['CreateClientNotificationRequest'];
export type UpdateClientNotificationRequest = components['schemas']['UpdateClientNotificationRequest'];
export type ClientNotificationCard = components['schemas']['ClientNotificationCard'];
export type ReadClientNotificationRequest = components['schemas']['ReadClientNotificationRequest'];

// client base
export type ClientListItemPagedResponse = components['schemas']['ClientListItemPagedResponse'];
export type ClientListItem = components['schemas']['ClientListItem'];
export type ClientListCountryItem = components['schemas']['ClientListCountryItem'];
export type ClientListUserItem = components['schemas']['ClientListUserItem'];
export type AuthenticationType = components['schemas']['AuthenticationType'];
export type CreateClientRequest = components['schemas']['CreateClientRequest'];
export type ClientCard = components['schemas']['ClientCard'];
export type UpdateClientRequest = components['schemas']['UpdateClientRequest'];
export type DeleteClientRequest = components['schemas']['DeleteClientRequest'];

// client reader card
export type ReaderCardListItemPagedResponse = components['schemas']['ReaderCardListItemPagedResponse'];
export type ReaderCardListItem = components['schemas']['ReaderCardListItem'];
export type Purpose = components['schemas']['Purpose'];
export type CreateReaderCardRequest = components['schemas']['CreateReaderCardRequest'];
export type ReaderCardById = components['schemas']['ReaderCardById'];
export type UpdateReaderCardRequest = components['schemas']['UpdateReaderCardRequest'];
export type ReaderCardByClientId = components['schemas']['ReaderCardByClientId'];

// client research topic
export type ReaderCardByIdResearchTopic = components['schemas']['ReaderCardByIdResearchTopic'];
export type ReaderCardListResearchTopicItem = components['schemas']['ReaderCardListResearchTopicItem'];
export type ResearchTopicListItem = components['schemas']['ResearchTopicListItem'];
// export type ResearchTopicWithFilesDto = any; //components['schemas']['ResearchTopicWithFilesDto'];
export type ResearchTopicListItemPagedResponse = components['schemas']['ResearchTopicListItemPagedResponse'];
export type ResearchTopicWithFilesDtoPagedResult = any; //components['schemas']['ResearchTopicWithFilesDtoPagedResult'];
export type CreateResearchTopicRequest = components['schemas']['CreateResearchTopicRequest'];
export type UpdateResearchTopicRequest = components['schemas']['UpdateResearchTopicRequest'];
export type UpdateResearchTopicActivityRequest = components['schemas']['UpdateResearchTopicActivityRequest'];
export type ResearchTopicByClientIdCardPagedResponse = components['schemas']['ResearchTopicByClientIdCardPagedResponse'];
export type ResearchTopicByClientIdCard = components['schemas']['ResearchTopicByClientIdCard'];
export type ResearchTopicByIdCard = components['schemas']['ResearchTopicByIdCard'];

export const PURPOSE_WORK_TASK = 'WorkTask';
export const PURPOSE_EDUCATION = 'StudyResearch';
export const PURPOSE_PRIVATE = 'PrivateResearch';

export const CLIENT_TYPE_INDIVIDUAL = 'Individual';
export const CLIENT_TYPE_ORG = 'Organization';
export const CLINET_STATUS_ACTIVE = 'Active';
export const CLIENT_STATUS_UNFINISHED = 'Unfinished';
export const CLIENT_STATUS_DELETED = 'Deleted';

export interface ReadersCard {
  education: string;
  degree: string;
  files: string[];
}

export enum ClientType {
  Individual = 'Individual',
  Organization = 'Organization'
}

export enum ClientStatus {
  Active = 'Active',
  Unfinished = 'Unfinished',
  Deleted = 'Deleted'
}
